import PageTemplate from "../components/templates/PageTemplate"
import ProjectTemplate from "../components/templates/ProjectTemplate"
import CalculatorTemplate from "../components/templates/CalculatorTemplate"

export default {
  page: PageTemplate,
  project: ProjectTemplate,
  calculator: CalculatorTemplate,
}
